import { render } from "./QuestionsMultiChoice.vue?vue&type=template&id=2795c070"
import script from "./QuestionsMultiChoice.vue?vue&type=script&lang=js"
export * from "./QuestionsMultiChoice.vue?vue&type=script&lang=js"

import "./QuestionsMultiChoice.vue?vue&type=style&index=0&id=2795c070&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__